var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenerativeAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feature/generative-ai"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16853 3.76922C7.98176 3.41026 7.46819 3.41026 7.28142 3.76922L6.64273 4.99673C6.59534 5.08782 6.52105 5.16211 6.42997 5.2095L5.6469 5.61693H1V6.96694H5.64765L6.42997 7.37398C6.52105 7.42137 6.59534 7.49566 6.64273 7.58675L7.28142 8.81426C7.46819 9.17322 7.98176 9.17322 8.16853 8.81426L8.80722 7.58675C8.85461 7.49566 8.9289 7.42137 9.01998 7.37398L10.2475 6.73529C10.6065 6.54852 10.6065 6.03496 10.2475 5.84819L9.01998 5.2095C8.9289 5.16211 8.85461 5.08782 8.80722 4.99673L8.16853 3.76922Z",
    fill: "url(#paint0_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4129 17.0781C7.54566 16.8353 7.89429 16.8353 8.02705 17.0781L8.55466 18.0428C8.58678 18.1015 8.63507 18.1498 8.69379 18.1819L9.65851 18.7095C9.90125 18.8423 9.90125 19.1909 9.65851 19.3237L8.69379 19.8513C8.63507 19.8834 8.58678 19.9317 8.55466 19.9904L8.02705 20.9551C7.89429 21.1979 7.54566 21.1979 7.4129 20.9551L6.88528 19.9904C6.85316 19.9317 6.80487 19.8834 6.74615 19.8513L5.78143 19.3237C5.53869 19.1909 5.53869 18.8423 5.78143 18.7095L6.74615 18.1819C6.80487 18.1498 6.85316 18.1015 6.88528 18.0428L7.4129 17.0781Z",
    fill: "url(#paint1_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.585 4.53844C13.796 3.89669 14.7039 3.89669 14.9149 4.53844L16.6101 9.69279C14.7275 10.1849 12.2541 11.4942 9.48162 14.5694L6.02183 13.4315C5.38009 13.2205 5.38009 12.3126 6.02183 12.1016L11.3774 10.3402C11.5886 10.2708 11.7542 10.1052 11.8236 9.89398L13.585 4.53844Z",
    fill: "url(#paint2_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8395 15.6874C13.6477 12.9545 15.6112 11.3313 17.3164 10.404L22.4781 12.1016C23.1198 12.3126 23.1198 13.2205 22.4781 13.4315L17.1225 15.1928C16.9113 15.2623 16.7457 15.4279 16.6762 15.6391L14.9149 20.9947C14.7039 21.6364 13.796 21.6364 13.585 20.9947L11.8395 15.6874Z",
    fill: "url(#paint3_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16853 3.76922C7.98176 3.41026 7.46819 3.41026 7.28142 3.76922L6.64273 4.99673C6.59534 5.08782 6.52105 5.16211 6.42997 5.2095L5.6469 5.61693H1V6.96694H5.64765L6.42997 7.37398C6.52105 7.42137 6.59534 7.49566 6.64273 7.58675L7.28142 8.81426C7.46819 9.17322 7.98176 9.17322 8.16853 8.81426L8.80722 7.58675C8.85461 7.49566 8.9289 7.42137 9.01998 7.37398L10.2475 6.73529C10.6065 6.54852 10.6065 6.03496 10.2475 5.84819L9.01998 5.2095C8.9289 5.16211 8.85461 5.08782 8.80722 4.99673L8.16853 3.76922Z",
    fill: "url(#paint4_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4129 17.0781C7.54566 16.8353 7.89429 16.8353 8.02705 17.0781L8.55466 18.0428C8.58678 18.1015 8.63507 18.1498 8.69379 18.1819L9.65851 18.7095C9.90125 18.8423 9.90125 19.1909 9.65851 19.3237L8.69379 19.8513C8.63507 19.8834 8.58678 19.9317 8.55466 19.9904L8.02705 20.9551C7.89429 21.1979 7.54566 21.1979 7.4129 20.9551L6.88528 19.9904C6.85316 19.9317 6.80487 19.8834 6.74615 19.8513L5.78143 19.3237C5.53869 19.1909 5.53869 18.8423 5.78143 18.7095L6.74615 18.1819C6.80487 18.1498 6.85316 18.1015 6.88528 18.0428L7.4129 17.0781Z",
    fill: "url(#paint5_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.585 4.53844C13.796 3.89669 14.7039 3.89669 14.9149 4.53844L16.6101 9.69279C14.7275 10.1849 12.2541 11.4942 9.48162 14.5694L6.02183 13.4315C5.38009 13.2205 5.38009 12.3126 6.02183 12.1016L11.3774 10.3402C11.5886 10.2708 11.7542 10.1052 11.8236 9.89398L13.585 4.53844Z",
    fill: "url(#paint6_linear_606_12003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8395 15.6874C13.6477 12.9545 15.6112 11.3313 17.3164 10.404L22.4781 12.1016C23.1198 12.3126 23.1198 13.2205 22.4781 13.4315L17.1225 15.1928C16.9113 15.2623 16.7457 15.4279 16.6762 15.6391L14.9149 20.9947C14.7039 21.6364 13.796 21.6364 13.585 20.9947L11.8395 15.6874Z",
    fill: "url(#paint7_linear_606_12003)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_606_12003",
    x1: 11.9797,
    y1: 3.5,
    x2: 11.9797,
    y2: 21.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43C7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerativeAi);
export default __webpack_public_path__ + "static/media/generative-ai.6e8807d88be2d37b2f70afbb6dea7490.svg";
export { ForwardRef as ReactComponent };